import React from 'react';
import { FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import { useTheme } from 'styled-components';

interface LogInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value: string | undefined;
  label: string | undefined;
}

const LogInput: React.FC<LogInputProps> = ({ value, label, name }) => {
  const theme = useTheme();
  return (
    <FormGroup controlId={name}>
      <FormLabel style={{ color: theme.colors.textoAzul, marginBottom: '2px' }}>
        {label}
      </FormLabel>
      <FormControl
        value={value}
        name={name}
        readOnly
        style={{
          border: 'none',
          textAlign: 'left',
          padding: '5px 10px',
          backgroundColor: '#ebf0f8',
        }}
      />
    </FormGroup>
  );
};

export default LogInput;
